import { Module } from "vuex";
import { StoreState } from "@/store/type";
import state, { IDuplicateBookingsState } from "./state";
import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const DuplicateBookingsModule: Module<IDuplicateBookingsState, StoreState> = {
  state,
  mutations,
  actions,
  getters,
};

export default DuplicateBookingsModule;
